import { Directive, ElementRef, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';
import { SearchEntityResult } from "../../api/models/search-entity-result";
import { AnalyticsService } from "../service/analytics/analytics.service";
import { CartService } from '../service/cart/cart.service';

@Directive({
  selector: '[appPurchase]'
})
export class PurchaseDirective {
  loading = false;

  @HostBinding('class.is-loading')
  get isLoading() {
    return this.loading;
  }

  @HostBinding('style.pointer-events')
  get pointerEvents() {
    return this.loading ? 'none' : 'auto';
  }

  @Input()
  appPurchase!: SearchEntityResult;

  @Input()
  listPrice: string = "N/A";

  @Input()
  currencyCode: string = "N/A";

  @Input()
  englishDisplayString: string = "";

  @Input()
  hrefHolder: string = "";

  @Output()
  showAddToCartErrorChange = new EventEmitter<boolean>();

  constructor(private el: ElementRef,
    private analyticsService: AnalyticsService,
    private cartService: CartService) {
  }

  @HostListener('click', ['$event']) onClick($event: any) {
    if (this.loading) return;

    this.showAddToCartErrorChange.emit(false);

    if (this.appPurchase.purchaseUrl?.purchaseType === 'CART') {
      this.loading = true;

      const params = {
        url: this.appPurchase.purchaseUrl.url!,
        partNumber: this.appPurchase.partNumber ?? 'N/A',
        serviceAssociation: this.appPurchase.purchaseUrl.serviceAssociation ?? false
      };

      this.cartService.addToCart(params).subscribe({
        next: response => {
          if (response.webCartId) {
            this.analyticsService.trackAddToCart(this.appPurchase.partNumber ?? 'N/A', this.listPrice, this.currencyCode);
            window.location.href = this.appPurchase.cartRedirectUrl ?? '/en/cart';
          } else {
            this.loading = false;
            this.showErrorMessage();
          }
        },
        error: () => {
          this.loading = false;
          this.showErrorMessage();
        }
      });

    } else {
      this.analyticsService.trackResultClick(this.hrefHolder, this.appPurchase, this.englishDisplayString);
      window.location.href = this.hrefHolder;
    }
  }

  showErrorMessage(): void {
    this.showAddToCartErrorChange.emit(true);
  }
}
